import React, {useEffect, useState} from 'react';
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";
import {useNotifications} from "context/NotificationContext";
import {Contact} from "../../../types/Contact";

type Props = {
    contact: Contact | null
    show: boolean
    onDelete?: (contact: Contact) => any
    onDeleteFail?: (contact: Contact, error: unknown) => any
    onCancel?: () => any
}

function DeleteContact(props: Props) {
    const {contact, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(contact?.full_name || 'this contact');
    const {mutateAsync: deleteContact} = useMutation(ngage.contacts.destroy)

    const {notify} = useNotifications()

    useEffect(() => {
        if(contact) setName(contact.full_name)
    }, [contact]);

    async function handleDeleteContact() {
        if (contact) {
            try {
                await deleteContact(contact.id)
                await invalidate('contacts.all')

                notify("success", "Contact Deleted", `${contact.full_name} has been permanently removed`)
                if (onDelete) onDelete(contact)
            } catch (error) {
                notify("error", "Contact Not Deleted", `${contact.full_name} could not be removed`)
                if (onDeleteFail) onDeleteFail(contact, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Contact"
            body={`Are you sure you want to permanently delete '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteContact}
            onCancel={handleCancel}
        />
    );
}

export default DeleteContact;